import type {
  GutBodyConnectionsColorVariant,
  GutBodyConnectionsOrgan,
} from '@repo/types';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
import styles from './GutBodyConnectionsOrganList.module.css';
import { GutBodyConnectionsOrganBadge } from '#components/GutBodyConnectionsOrganBadge';

type OrganRowProps = {
  organ: GutBodyConnectionsOrgan;
  /** `kit.age_at_sampling`, in days. */
  age: number;
  pregnant: boolean;
  colorVariant?: GutBodyConnectionsColorVariant;
  /** Omitted where the list only names the organs, as the PDF report would. */
  onSelect?: () => void;
};

export default function OrganRow({
  organ,
  age,
  pregnant,
  colorVariant,
  onSelect,
}: OrganRowProps) {
  const content = (
    <>
      <GutBodyConnectionsOrganBadge
        organ={organ}
        age={age}
        pregnant={pregnant}
        colorVariant={colorVariant}
      />
      <Typography variant='body-s' className={styles.name}>
        {organ.display_name}
      </Typography>
      {onSelect && (
        <Icon name='chevronForward' size='m' className={styles.chevron} />
      )}
    </>
  );

  return (
    <li className={styles.row}>
      {onSelect ? (
        <button type='button' className={styles.content} onClick={onSelect}>
          {content}
        </button>
      ) : (
        <span className={styles.content}>{content}</span>
      )}
    </li>
  );
}
